import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Link as ChakraLink, ModalBody } from '@chakra-ui/react';
import HeaderSideNav from '../HeaderSideNav';
import { containerItemStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function AuthSideNav(_ref) {
  var onClickHeaderTitle = _ref.onClickHeaderTitle,
    header = _ref.header,
    logout = _ref.logout,
    labels = _ref.labels;
  var accountLinks = labels === null || labels === void 0 ? void 0 : labels.accountLinks;
  return _jsxs(_Fragment, {
    children: [_jsx(HeaderSideNav, {
      title: header,
      onClickTitle: onClickHeaderTitle,
      dataTestId: "Global-UserName-Mobile"
    }), _jsxs(ModalBody, {
      p: "0",
      "data-testid": "authSideNav",
      children: [accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks.map(accountLink => _jsx(Box, _objectSpread(_objectSpread({}, containerItemStyle), {}, {
        children: _jsx(ChakraLink, {
          href: accountLink.url,
          "data-testid": "".concat(accountLink.title, "Button-Mobile"),
          children: accountLink.title
        })
      }))), _jsx(Box, _objectSpread(_objectSpread({}, containerItemStyle), {}, {
        onClick: logout,
        "data-testid": "Global-Logout-Mobile",
        children: labels === null || labels === void 0 ? void 0 : labels.logOut
      }))]
    })]
  });
}